import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'update',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'noSurveyFound',
    loadChildren: () =>
      import('./no-survey-found/no-survey-found.module').then(
        (m) => m.NoSurveyFoundPageModule
      ),
  },
  {
    path: 'logout',
    loadChildren: () =>
      import('./logout/logout.module').then((m) => m.LogoutPageModule),
  },
  {
    path: 'about',
    loadChildren: () =>
      import('./about/about.module').then((m) => m.AboutPageModule),
  },
  {
    path: 'device',
    loadChildren: () =>
      import('./device/device.module').then((m) => m.DevicePageModule),
  },
  {
    // Page cachée de création de device standalone (5 appuis sur le
    // bouton invisible du header de la page login)
    path: 'deviceCreate',
    loadChildren: () =>
      import('./device-create/device-create.module').then(
        (m) => m.DeviceCreatePageModule
      ),
  },
  {
    path: 'startSurvey',
    loadChildren: () =>
      import('./start-survey/start-survey.module').then(
        (m) => m.StartSurveyPageModule
      ),
  },
  {
    path: 'surveyContent',
    loadChildren: () =>
      import('./survey-content/survey-content.module').then(
        (m) => m.SurveyContentPageModule
      ),
  },
  {
    path: 'selectSurvey',
    loadChildren: () =>
      import('./select-survey/select-survey.module').then(
        (m) => m.SelectSurveyPageModule
      ),
  },
  {
    path: 'alertUnsubscribed',
    loadChildren: () =>
      import('./alert-unsubscribed/alert-unsubscribed.module').then(
        (m) => m.AlertUnsubscribedPageModule
      ),
  },
  {
    path: 'quit-app',
    loadChildren: () =>
      import('./quit-app/quit-app.module').then((m) => m.QuitAppPageModule),
  },
  {
    path: 'send-answers',
    loadChildren: () =>
      import('./send-answers/send-answers.module').then(
        (m) => m.SendAnswersPageModule
      ),
  },
  {
    path: 'update-app',
    loadChildren: () =>
      import('./update-app/update-app.module').then(
        (m) => m.UpdateAppPageModule
      ),
  },
  {
    path: 'privacy-policies',
    loadChildren: () =>
      import('./privacy-policies/privacy-policies.module').then(
        (m) => m.PrivacyPoliciesPageModule
      ),
  },
  {
    path: 's/:shortId',
    loadChildren: () => import('./web/web.module').then((m) => m.WebPageModule),
  },
  {
    path: 'k/:shortId',
    loadChildren: () => import('./web/web.module').then((m) => m.WebPageModule),
  },
  {
    path: 'preview/:shortId',
    loadChildren: () => import('./web/web.module').then((m) => m.WebPageModule),
  },
  {
    path: 'web',
    loadChildren: () =>
      import('./web-v2/web-v2.module').then((m) => m.Webv2PageModule),
  },
  {
    path: 'survey-content-monopage',
    loadChildren: () =>
      import('./survey-content-monopage/survey-content-monopage.module').then(
        (m) => m.SurveyContentMonopagePageModule
      ),
  },
  {
    path: 'visitors',
    loadChildren: () =>
      import('./visitors/visitors.module').then((m) => m.VisitorsPageModule),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
